import { AWARD_CATEGORIES } from './evaluation';

/**
 * Valid award categories from the schema
 */
export const VALID_CATEGORIES = AWARD_CATEGORIES;

/**
 * Mapping from backend pillar names to display names
 */
export const PILLAR_MAPPING: Record<string, string> = {
  'Agri-business & Food': 'Sinar Mas Agribusiness and Food',
  'Pulp & Paper': 'APP Group',
  'Developer & Real Estate': 'Sinar Mas Land',
  'Financial Services': 'Sinar Mas Financial Services & Mining',
  'Energy & Infrastructure': 'Sinar Mas Energy and Infrastructure',
  'Communications & Technology': 'Sinar Mas Communication & Technology',
  Healthcare: 'Sinar Mas Healthcare',
  Others: 'Sinar Mas Education',
};

/**
 * Transform judge's pillar to display name for proper comparison with submission data
 */
export const getPillarDisplayName = (backendPillarName: string): string => {
  return PILLAR_MAPPING[backendPillarName] || backendPillarName;
};
